import { useState, useCallback } from 'react';

export const useChemoUI = () => {
    const [showForm, setShowForm] = useState(false);
    const [currentReport, setCurrentReport] = useState(null);

    const [snackbar, setSnackbar] = useState({
        open: false,
        message: '',
        severity: 'success'
    });

    const [resultDialog, setResultDialog] = useState({
        open: false,
        data: null
    });

    const [messageDialog, setMessageDialog] = useState({
        open: false,
        message: '',
        sending: false
    });

    const openNewReportForm = useCallback(() => {
        setShowForm(true);
        setCurrentReport(null);
    }, []);

    const openExistingReport = useCallback((report) => {
        setCurrentReport(report);
        setShowForm(true);
    }, []);

    const closeForm = useCallback(() => {
        setShowForm(false);
        setCurrentReport(null);
    }, []);

    const showSnackbar = useCallback((message, severity = 'success') => {
        setSnackbar({
            open: true,
            message,
            severity
        });
    }, []);

    const closeSnackbar = useCallback(() => {
        setSnackbar(prev => ({ ...prev, open: false }));
    }, []);

    const showResultDialog = useCallback((data) => {
        setResultDialog({
            open: true,
            data
        });
    }, []);

    const closeResultDialog = useCallback(() => {
        setResultDialog({
            open: false,
            data: null
        });
        closeForm();
    }, [closeForm]);

    const openMessageDialog = useCallback(() => {
        setMessageDialog({ open: true, message: '', sending: false });
    }, []);

    const closeMessageDialog = useCallback(() => {
        setMessageDialog({ open: false, message: '', sending: false });
    }, []);

    const updateMessageText = useCallback((message) => {
        setMessageDialog(prev => ({ ...prev, message }));
    }, []);

    const setMessageSending = useCallback((sending) => {
        setMessageDialog(prev => ({ ...prev, sending }));
    }, []);

    return {
        showForm,
        currentReport,
        snackbar,
        resultDialog,
        openNewReportForm,
        openExistingReport,
        closeForm,
        showSnackbar,
        closeSnackbar,
        showResultDialog,
        closeResultDialog,
        messageDialog,
        openMessageDialog,
        closeMessageDialog,
        updateMessageText,
        setMessageSending
    };
};
